import { render, staticRenderFns } from "./TalkizyConnect.vue?vue&type=template&id=246a3c02&"
import script from "./TalkizyConnect.vue?vue&type=script&lang=js&"
export * from "./TalkizyConnect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports